import { useState } from "react";
import { discussionItems } from "@/mocks/gossip";

function DiscussionCard({
  title,
  snippet,
  commentCount,
  agree,
  time,
}: {
  title: string;
  snippet: string;
  commentCount: string;
  agree: string;
  time: string;
}) {
  const [state, setState] = useState<"none" | "agree" | "against">("none");

  const select = (v: "agree" | "against") => setState((cur) => (cur === v ? "none" : v));

  return (
    <article className="rounded-2xl bg-background-50 border border-background-200 p-5 md:p-6 hover:border-primary-200 transition-colors flex flex-col gap-4">
      <div className="flex items-center justify-between text-xs text-foreground-500">
        <span className="inline-flex items-center gap-1.5 text-secondary-600">
          <i className="ri-message-2-line text-sm"></i> 爆料热议 · {time}
        </span>
        <span className="inline-flex items-center gap-1 text-accent-500">
          <i className="ri-fire-line"></i> 评论区 {commentCount}
        </span>
      </div>

      <h3 className="font-heading text-foreground-950 font-bold leading-snug text-base md:text-lg">
        {title}
      </h3>
      <p className="text-sm text-foreground-600 leading-relaxed">{snippet}</p>

      <div className="mt-auto flex flex-col sm:flex-row items-stretch gap-3 pt-2">
        <button
          onClick={() => select("agree")}
          className={`flex-1 inline-flex items-center justify-center gap-2 rounded-full text-sm px-4 py-2.5 transition-colors cursor-pointer whitespace-nowrap ${
            state === "agree"
              ? "bg-secondary-500 text-background-50"
              : "bg-secondary-100 text-secondary-900 hover:bg-secondary-200"
          }`}
        >
          <i className={`${state === "agree" ? "ri-thumb-up-fill" : "ri-thumb-up-line"}`}></i>
          吃这瓜 {agree}
        </button>
        <button
          onClick={() => select("against")}
          className={`flex-1 inline-flex items-center justify-center gap-2 rounded-full text-sm px-4 py-2.5 transition-colors cursor-pointer whitespace-nowrap ${
            state === "against"
              ? "bg-primary-500 text-background-50"
              : "bg-primary-100 text-primary-800 hover:bg-primary-200"
          }`}
        >
          <i className={`${state === "against" ? "ri-thumb-down-fill" : "ri-thumb-down-line"}`}></i>
          存疑待查
        </button>
        <a
          href="#discussion"
          className="flex-1 inline-flex items-center justify-center gap-2 rounded-full bg-background-100 text-foreground-700 hover:text-primary-600 text-sm px-4 py-2.5 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-chat-smile-2-line"></i> 去围观
        </a>
      </div>
    </article>
  );
}

export default function Discussion() {
  return (
    <section id="discussion" className="relative py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8 md:mb-10">
          <div>
            <span className="inline-flex items-center gap-1.5 text-accent-500 text-xs font-medium tracking-wide mb-3">
              <i className="ri-chat-history-line"></i> 评论区在吵什么
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-extrabold text-foreground-950">
              爆料热议，瓜友们都在站哪边
            </h2>
          </div>
          <p className="text-sm text-foreground-600 max-w-sm md:text-right">
            同一张图，两拨人。吃瓜不只是看，评论区本身就是一场现场直播。
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 md:gap-6">
          {discussionItems.map((d) => (
            <DiscussionCard key={d.id} {...d} />
          ))}
        </div>

        <div className="mt-8 rounded-2xl bg-background-100 border border-background-200 p-5 md:p-6 flex flex-col gap-4 md:flex-row md:items-center">
          <div className="flex-1 flex flex-col gap-1">
            <span className="text-sm font-semibold text-foreground-900">你有话想插一嘴？</span>
            <span className="text-xs text-foreground-600">
              输入框仅供展示，未接真实接口——想上墙去对应瓜条下开麦。
            </span>
          </div>
          <div className="flex flex-col sm:flex-row gap-3 md:gap-3 md:flex-1 md:items-center">
            <input
              type="text"
              placeholder="留下你的看法…（演示用，不提交）"
              className="flex-1 rounded-full bg-background-50 border border-background-300 px-4 py-2.5 text-sm outline-none focus:border-primary-400 placeholder:text-foreground-400"
            />
            <button className="inline-flex items-center justify-center gap-2 rounded-full bg-foreground-950 hover:bg-foreground-800 text-background-50 text-sm px-5 py-2.5 transition-colors cursor-pointer whitespace-nowrap">
              <i className="ri-send-plane-line"></i> 发一条
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}